import { Injectable } from '@angular/core';
import { SubscriptionTypeEnum } from '@enums/subscriptionTypeEnum';
import { CustomerPermission } from '@models/customerPermission';
import { SubscriptionTypePermission } from '@models/subscriptionTypePermission';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { CustomersService } from '@services/entity/customers.service';
import { SubscriptionsService } from '@services/entity/subscriptions.service';
import { UsersService } from '@services/entity/users.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {

  constructor(private usersService: UsersService, private subscriptionsService: SubscriptionsService, private authenticationService: AuthenticationService) { }

  public async getPermissionsOfCurrentCustomer(): Promise<CustomerPermission[] | SubscriptionTypePermission[]> {
    var user = this.authenticationService.getLoggedInUser();

    if (user.subscriptionTypeId == SubscriptionTypeEnum.Enterprise) {
      var customerPermissions = await this.usersService.getCurrentCustomerPermissionsAsync();
     /* var customerPermissions = await this.customersService.getCustomerPermissionsAsync(user.selectedCustomerId);*/

      return customerPermissions;
    }
    else {
      var subscriptionTypePermissions = await this.subscriptionsService.getSubscriptionTypePermissionsAsync(user.subscriptionTypeId);

      return subscriptionTypePermissions;
    }
  }
}
